<template>
    <b-modal id="received_delete" ref="received_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.received.data.attributes.item + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('received_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteReceivedItem">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "ItemsReceivedDeleteModal",

    components: {
        StateButton
    },

    props: [
        'received'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteReceivedItem() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteReceivedItem', this.received)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-received');

                            this.$notify('error filled', 'Success!', 'Deleted the received item!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('received_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
